import React from 'react'
import { connect } from 'react-redux'
import { Grid } from '@material-ui/core'
import ToggleViewButton from '../Main/ToggleViewButton'
import RightButtons from '../Main/ResponseView/RightButtons'
import FormViewButtons from '../Main/FormViewButtons'

export default connect(
  state => ({ viewSelected: state.signupForm.addOrEdit.previewResponseView }),
  null
)(({ viewSelected }) => (
  <Grid container spacing={24} style={{ paddingTop: 0, width: '100%', margin: 0 }}>
    <Grid item xs={6}>
      <Grid container justify="flex-start">
        <Grid item style={{ padding: '7px 0 0 7px' }}>
          <ToggleViewButton small />
        </Grid>
      </Grid>
    </Grid>
    <Grid item xs={6}>
      {viewSelected === 'preview' ? <FormViewButtons /> : <RightButtons icon />}
    </Grid>
  </Grid>
))
